import React, { useRef, useState, useEffect } from 'react';
import { calculateSizeAndPositionOnParent } from '../../../../../util/ECG';

export const Brush = ({ divSize, onScroll }) => {
  const refBrush = useRef();
  const BrushSizeAndPosition = calculateSizeAndPositionOnParent([
    {
      parentSize: divSize,
      elementXPositionPercentage: 0,
      elementYPositionPercentage: 75,
      elementWidthPercentage: 25,
      elementHeightPercentage: 25,
    },
  ]);

  const BrushBounds = calculateSizeAndPositionOnParent([
    {
      parentSize: divSize,
      elementXPositionPercentage: 0,
      elementYPositionPercentage: 75,
      elementWidthPercentage: 100,
      elementHeightPercentage: 25,
    },
  ]);
  const [brushPosition, setBrushPosition] = useState({});
  const [left, setLeft] = useState(0);
  const [mouseDown, setMouseDown] = useState(false);

  useEffect(() => {
    const onMouseDown = (e) => {
      // OnClick we save in BrushPosition.x where my cursor starts, in brushPosition.left the start left
      if (e.buttons === 1) {
        setBrushPosition({ x: e.clientX, y: e.clientY, left });
      }
      setMouseDown(true);
    };

    const onMouseMove = (e) => {
      if (e.buttons === 1 && mouseDown) {
        // movementX =  (where i am = e.clientX) minus (where i start = brushPosition.x)
        const movementX = e.clientX - brushPosition.x;
        // _left = the old left = brushPosition.left + how much i move = movementX
        let _left = brushPosition.left + movementX;
        // max = (the maximum width = rusBounds.width) minus (the size of the brush = BrushSizeAndPosition.width)
        const max = BrushBounds.width - BrushSizeAndPosition.width - 2;
        // _left = a number in between 0 and max
        _left = Math.min(max, Math.max(0, _left));

        setLeft(_left);
        onScroll(_left);
      }
    };

    refBrush.current.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', () => {
      setMouseDown(false);
    });

    return () => {
      refBrush && refBrush.current && refBrush.current.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('mousemove', onMouseMove);
    };
  }, [brushPosition, BrushSizeAndPosition, BrushBounds, left, onScroll]);
  const { position, top, width, height } = BrushSizeAndPosition;
  return (
    <div
      ref={refBrush}
      className="selector"
      style={{
        position,
        top,
        left,
        width,
        height,
      }}
    />
  );
};

export default Brush;
